<tree-view                                  
           [treeDataProvider]="menuDataProvider"
           (nodeSelected)="onNodeSelected($event)" 
           (menuClick)="onMenuClick($event)"
           (addClick)="onAddClick($event)"
           [imageSet]="imageSet"
           >
</tree-view>